import { css } from '@emotion/react'
import styled from '@emotion/styled'
import { theme } from 'styles/theme/hav-theme'

type DataWrapProps = {
  achieved?: boolean
}
export const DataWrap = styled.div<DataWrapProps>`
  display: flex;
  align-items: center;
  gap: ${theme.spacing.xs};

  span {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  ${({ achieved }) =>
    achieved &&
    css`
      svg {
        path {
          fill: ${theme.colors.alert.success.dark};
        }
      }

      span,
      strong {
        color: ${theme.colors.alert.success.dark};
        font-family: ${theme.typography.family.bold};
      }
    `}
`
